module.exports = __webpack_public_path__ + "img/mastercard.f85b4a4.png";